"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedListFieldView = void 0;
var multi_list_input_1 = require("../../../components/input/multi.list.input");
var nested_list_chooser_state_1 = require("../../multi.list.chooser/nested.list.chooser.state");
exports.NestedListFieldView = {
    viewInline: function (field) {
        return field.hasValue() ? field.displayValue : null;
    },
    viewDetail: function (field) {
        return null;
    },
    viewEdit: function (field, ctrl) {
        var inputState = ctrl.changeState.getState(field.id);
        if (inputState == null) {
            inputState = new nested_list_chooser_state_1.NestedListChooserState(field);
            inputState.onValue(function () { return setManualValue(field, inputState); });
            ctrl.changeState.addState(field.id, inputState);
        }
        return multi_list_input_1.MultiListInput.view(inputState);
    }
};
function setManualValue(field, inputState) {
    var value = inputState.value;
    if (value != null) {
        field.Mutator.manual(Array.from(value));
    }
    else {
        field.Mutator.clear();
    }
}
//# sourceMappingURL=nested.list.field.view.js.map